import { observable, action, flow, set, computed } from 'mobx';
import {
  apiGetFreeShippingList,
  apiGetFreeShippingAmount,
  apiGetAddressList
} from './FreeShippingServ';
import { isEmpty } from 'lodash';
import Stores from 'config/Stores';

const getProductList = function* () {
  try {
    const result = yield apiGetFreeShippingList();
    freeShippingMod.productList = result.data || [];
  } catch (err) {}
};

const getFreeShippingAmount = function* () {
  if (!freeShippingMod.freeShippingNo) return;
  try {
    const result = yield apiGetFreeShippingAmount(freeShippingMod.freeShippingNo);
    freeShippingMod.freeShippingAmount = (result.data && result.data.amount) || 0;
    freeShippingMod.isOrder = !!(result.data && result.data.isOrder);
    freeShippingMod.isExpired = !!(result.data && result.data.isExpired);
    freeShippingMod.userAddressId = (result.data && result.data.userAddressId) || '';
    freeShippingMod.addressInfo = (result.data && result.data.addressInfo) || {};
    freeShippingMod.curInfo = {
      memberCard: result.data && result.data.userCard,
      realName: result.data && result.data.realName
    };
    // 主单为代客场景需要存客的信息
    if (result.data && result.data.dgStatus !== 0) {
      const decyptName = yield Stores.AppMod.getDecyptMsg({
        scene: 101,
        id: result.data && result.data.placeUserId,
        channel: ''
      });
      freeShippingMod.dgMemberInfo = {
        memberCard: result.data && result.data.userCard,
        realName: result.data && result.data.realName,
        memberName: decyptName,
        origin: result.data && result.data.origin == 2 ? 'member' : 'shop',
        placeUserId: result.data && result.data.placeUserId
      };
    }
  } catch (err) {}
};

const getAddressList = function* () {
  try {
    const result = yield apiGetAddressList();
    return (result.data && result.data.list) || [];
  } catch (err) {
    return [];
  }
};

const changeState = (obj) => {
  Object.keys(obj).forEach((key) => {
    freeShippingMod[key] = obj[key];
  });
};

const reset = () => {
  freeShippingMod.selectProductList = [];
  freeShippingMod.productList = [];
  freeShippingMod.freeShippingNo = '';
  freeShippingMod.freeShippingAmount = 0;
  freeShippingMod.isOrder = false;
  freeShippingMod.isExpired = false;
  freeShippingMod.userAddressId = '';
  freeShippingMod.addressInfo = {};
  freeShippingMod.productInfo = {};
  freeShippingMod.dgMemberInfo = {};
};

const changeProductNum = (productId, num) => {
  const list = [...freeShippingMod.productList];
  const currentProduct = list.find((item) => item.itemId === productId) || {};
  if (isEmpty(currentProduct)) return;

  const productInfo = { ...freeShippingMod.productInfo };
  productInfo.itemNum = num;
  freeShippingMod.productInfo = productInfo;

  currentProduct.num = num;
  freeShippingMod.productList = list;
  const selectIndex = freeShippingMod.selectProductList.findIndex(
    (item) => item.itemId === productId
  );
  if (selectIndex > -1) {
    if (num === 0) {
      freeShippingMod.selectProductList.splice(selectIndex, 1);
      return;
    }
    const selectList = [...freeShippingMod.selectProductList];
    selectList[selectIndex].num = num;
    freeShippingMod.selectProductList = selectList;
  } else {
    const selectList = [...freeShippingMod.selectProductList];
    selectList.push({ ...currentProduct, num });
    freeShippingMod.selectProductList = selectList;
  }
};

const freeShippingMod = observable({
  selectProductList: [], // 选择的商品列表
  productList: [], // 商品列表
  freeShippingNo: '', // 主单的单号
  reset: action(reset),
  changeState: action(changeState),
  getProductList: flow(getProductList),
  getFreeShippingAmount: flow(getFreeShippingAmount),
  getAddressList: flow(getAddressList),
  changeProductNum: action(changeProductNum),
  freeShippingAmount: 0, // 免邮门槛金额
  isOrder: false, // 是否已下单
  isExpired: false, // 是否已失效
  userAddressId: '', // 主单的地址id
  addressInfo: {}, // 主单地址不存在时返回的地址信息
  productInfo: {}, // 跳转到商品详情页的商品信息
  dgMemberInfo: {}, // 享包邮订单客的信息
  curInfo: {}, // 头部显示用户信息
  // 计算选中商品的总数量
  get totalQuantity() {
    return freeShippingMod.selectProductList.reduce((total, product) => {
      return total + (product.num || 0);
    }, 0);
  },
  // 计算选中商品的总金额
  get totalAmount() {
    return freeShippingMod.selectProductList.reduce((total, product) => {
      return total + (product.price || 0) * (product.num || 0);
    }, 0);
  },

  // 计算还差多少金额达到免邮门槛
  get diffFreeShippingAmount() {
    return freeShippingMod.freeShippingAmount > freeShippingMod.totalAmount
      ? freeShippingMod.freeShippingAmount - freeShippingMod.totalAmount
      : 0;
  }
});

export default freeShippingMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Product/FreeShipping/FreeShippingMod.js